import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Observable, forkJoin } from "rxjs";
import { catchError, take, timeout } from "rxjs/operators";
import { of } from "rxjs";

import { Utils } from "../../../../../shared/utils/Utils";
import {
  ProgramaPesv,
  ProgramaPesvPayload,
  ProgramaPesvService,
} from "../../../../../shared/services/programa-pesv.service";
import { TipoProgramaService } from "../../../../../shared/services/tipo-programa.service";



import { Router } from "@angular/router";
import {
  TipoRiesgoVialCreatePayload,
  TiposRiesgoVialService,
} from "../../../../../shared/services/tipos-riesgo-vial.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AdministracionService } from "../../../../../shared/services/administracion.services";
import { DigitalesService } from "../../../../../shared/services/digitales.service";
import { HttpEventType } from "@angular/common/http";
import { SeguimientosProgramaService } from "../../../../../shared/services/seguimientos-programa.service";

interface ProgramaFormValue {
  consecutivo: string;
  nombrePrograma: number | null;
  tipoPrograma: number | null;
  riesgoCriticoAsociado: number | null;
  proceso: number | null;
  area: number | null;
  objetivoPesvRelacionado: number | null;
  fechaInicio: string;
  fechaFin: string;
  objetivoGeneral: string;
}

interface CatalogoItem {
  id: number;
  descripcion: string;
  [key: string]: any;
}

// Config genérica para crear un ítem de catálogo desde un modal
interface CatalogoCrearConfig {
  descripcion: string;
  modal: any;
  createFn: (payload: {
    descripcion: string;
    estado: number;
  }) => Observable<any>;
  reloadFn: () => void;
  formControlName: keyof ProgramaFormValue;
  entidadNombre: string;
}

// 🆕 Config genérica para cargar un catálogo (GET simple)
interface CatalogoCargaConfig {
  getFn: () => Observable<any>;
  asignarA: (lista: CatalogoItem[]) => void;
}

@Component({
  selector: "app-programa",
  templateUrl: "./programa.component.html",
  styleUrls: ["./programa.component.scss"],
})
export class ProgramaComponent implements OnInit {
  programaForm!: FormGroup;
  formTipoRiesgo!: FormGroup;
  activeTab = 1;
  guardando = false;
  cargandoListado = false;
  cargandoNombres = false;
  cargandoCatalogos = false;
  programas: any[] = [];
  programasFiltrados: any[] = [];
  filtro = "";
  filtroEstado: number | null = null;
  pageSize = 10;
  page = 1;
  cargandoEdicion = false;
  nombresPrograma: CatalogoItem[] = [];
  tiposPrograma: CatalogoItem[] = [];
  procesos: CatalogoItem[] = [];
  areas: CatalogoItem[] = [];
  objetivosPesv: CatalogoItem[] = [];
  tiposRiesgoVial: CatalogoItem[] = [];
  readonly fechaMaximaInicio = this.obtenerFechaActual();
  consecutivo: any[] = [];
  // Estado de edición dentro del mismo formulario
  modoEdicion = false;
  idProgramaEditando: number | null = null;
  private seedingEdicion = false; // evita que el valueChanges de tipoPrograma limpie el riesgo mientras se están cargando datos de edición
  nit: string | null = null;
  administraciones: any[] = [];
  programaSeleccionadoDocs: any = null;
  documentosPlan: {
    path: string;
    name: string;
    url: string;
    isImage: boolean;
  }[] = [];
  nuevosArchivosDocs: { file: File; preview: string | null }[] = [];
  cargandoDocumentos = false;
  subiendoDocumentos = false;
  documentoSeleccionado: {
    name: string;
    path: string;
    url: string;
    urlSegura?: SafeResourceUrl;
    isImage: boolean;
    isPdf: boolean;
    tipo: string;
  } | null = null;
  programaResumen: any = null;
  cargandoResumen = false;
  resumen = {
    totalIndicadores: 0,
    totalActividades: 0,
    actividadesEnEjecucion: 0,
    totalSeguimientos: 0,
    ultimoSeguimiento: null as string | null,
    totalEvidencias: 0,
    totalEvaluaciones: 0,
    ultimaEvaluacion: null as string | null,
    avanceGeneral: 0,
    meta: "-",
  };

  programaReporteSeleccionado: any = null;
  reporteTipo: string = "resumen";
  reporteDesde: string = "";
  reporteHasta: string = "";
  generandoReporte: Record<string, boolean> = {
    resumen: false,
    indicadores: false,
    actividades: false,
    evidencias: false,
    seguimientos: false,
    evaluaciones: false,
  };

  reporteFechaMinima: string = ""; 
reporteFechaMaxima: string = "";

reportePeriodo: string = "completo"; // 🔹 nuevo
periodosReporte = [
  { id: "completo", nombre: "Todo el programa" },
  { id: "mes", nombre: "Mes actual" },
  { id: "trimestre", nombre: "Trimestre actual" },
  { id: "semestre", nombre: "Semestre actual" },
  { id: "anual", nombre: "Año actual" },
  { id: "personalizado", nombre: "Personalizado" },
];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private programaPesvService: ProgramaPesvService,    
    private tipoProgramaService: TipoProgramaService,    
    private router: Router,
    private tiposRiesgoVialService: TiposRiesgoVialService,
    private sanitizer: DomSanitizer,
    private administracionesServices: AdministracionService,
    private digitalesService: DigitalesService,   
    private seguimientosProgramaService: SeguimientosProgramaService,
   
  ) {}

  ngOnInit(): void {
    this.inicializarFormularios();
    this.cargarCatalogos();
    this.cargarProgramas();
    this.cargarAdministraciones();

  
  }

  private inicializarFormularios(): void {
    this.programaForm = this.fb.group({
      consecutivo: [{ value: "", disabled: true }],
    //  nombrePrograma: [null, Validators.required],
      tipoPrograma: [null, Validators.required],
      //riesgoCriticoAsociado: [null, Validators.required],
     // proceso: [null, Validators.required],
     // area: [null, Validators.required],
    //  objetivoPesvRelacionado: [null, Validators.required],
      fechaInicio: [
        "",
        [Validators.required, this.validarFechaPasada.bind(this)],
      ],
      fechaFin: [{ value: "", disabled: true }],
      objetivoGeneral: ["", [Validators.required, Validators.maxLength(2000)]],
    });
  }

  private validarFechaPasada(
    control: AbstractControl,
  ): ValidationErrors | null {
    if (!control.value) {
      return null;
    }
    return control.value > this.fechaMaximaInicio
      ? { fechaFutura: true }
      : null;
  }

  // 🆕 Carga TODOS los catálogos en paralelo con una sola bandera de carga
  private cargarCatalogos(): void {
    this.cargandoNombres = true;
    this.cargandoCatalogos = true;

    const catalogos: Record<string, Observable<any>> = {
     
      tipos: this.tipoProgramaService.getTiposActivos().pipe(catchError(() => of([]))),    
      
    };

    forkJoin(catalogos).subscribe((resultados) => {
    
      this.tiposPrograma = this.normalizarLista(resultados["tipos"]);
      
      this.cargandoCatalogos = false;
    });
    this.getConsecutivo();
  }

  private recargarCatalogo(config: CatalogoCargaConfig): void {
    config
      .getFn()
      .pipe(catchError(() => of([])))
      .subscribe((response: any) => {
        config.asignarA(this.normalizarLista(response));
      });
  }

  private getConsecutivo(): void {
    if (this.modoEdicion) return; // en edición no se pide consecutivo nuevo

    this.programaPesvService.getConsecutivo().subscribe({
      next: (response: any) => {
        this.consecutivo = response.consecutivo;
        this.programaForm.patchValue({ consecutivo: response.consecutivo });
      },
      error: () => {},
    });
  }

 

  private normalizarLista(response: any): CatalogoItem[] {
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.data)) return response.data;
    return [];
  }

  private crearItemCatalogo(config: CatalogoCrearConfig): void {
    const descripcion = config.descripcion?.trim();

    if (!descripcion) {
      Swal.fire("Error", "La descripción no puede estar vacía.", "error");
      return;
    }

    const payload = { descripcion: descripcion.toUpperCase(), estado: 1 };

    config.createFn(payload).subscribe({
      next: (response: any) => {
        const nuevoId = response?.data?.id || response?.id;
        config.modal.close();
        Swal.fire(
          "Éxito",
          `${config.entidadNombre} creado correctamente.`,
          "success",
        );
        config.reloadFn();

        if (nuevoId) {
          setTimeout(() => {
            this.programaForm.patchValue({ [config.formControlName]: nuevoId });
          }, 300);
        }
      },
      error: (error: any) => {
        const mensaje =
          error?.error?.error || `No se pudo crear: ${config.entidadNombre}.`;
        Swal.fire("Error", mensaje, "error");
      },
    });
  }

  // 🆕 Un único método para abrir cualquier modal (antes había 6 idénticos)
  abrirModal(modalRef: any, size: "lg" | "xl" = "lg"): void {
    this.modalService.open(modalRef, { centered: true, size });
  }



  crearNuevoTipoPrograma(descripcion: string, modal: any): void {
    this.crearItemCatalogo({
      descripcion,
      modal,
      createFn: (payload) => this.tipoProgramaService.createTipo(payload),
      reloadFn: () =>
        this.recargarCatalogo({
          getFn: () => this.tipoProgramaService.getTiposActivos(),
          asignarA: (lista) => (this.tiposPrograma = lista),
        }),
      formControlName: "tipoPrograma",
      entidadNombre: "Tipo de programa",
    });
  }




 

  cargarProgramas(): void {
    this.cargandoListado = true;

    this.programaPesvService.getAll().subscribe({
      next: (response: any) => {
        this.programas = this.normalizarLista(response);
        this.aplicarFiltro();
        this.cargandoListado = false;
      },
      error: () => {
        this.programas = [];
        this.programasFiltrados = [];
        this.cargandoListado = false;
      },
    });
  }

  aplicarFiltro(): void {
    const termino = String(this.filtro || "")
      .toLowerCase()
      .trim();

    let filtrados = this.programas.filter((programa) => {
      const coincideTexto =
        !termino ||
        [
          programa.nombreProgramaData?.descripcion || programa.nombre_programa,
          programa.objetivo_general,
          programa.tipoProgramaData?.descripcion,
          programa.riesgoCriticoData?.descripcion,
          programa.procesoData?.descripcion,
          programa.areaData?.descripcion,
        ]
          .filter((valor) => valor !== null && valor !== undefined)
          .some((valor) => String(valor).toLowerCase().includes(termino));

      const estadoPrograma = Number(programa.estado);
      const coincideEstado =
        this.filtroEstado === null || estadoPrograma === this.filtroEstado;

      return coincideTexto && coincideEstado;
    });

    filtrados = filtrados.sort((a, b) => {
      const estadoA = Number(a.estado) === 1 ? 0 : 1;
      const estadoB = Number(b.estado) === 1 ? 0 : 1;
      if (estadoA !== estadoB) return estadoA - estadoB;
      return (a.id || 0) - (b.id || 0);
    });

    this.programasFiltrados = filtrados;
    this.page = 1;
  }

  existeRegistroActivo(): boolean {
    return (this.programas || []).some(
      (item: any) => Number(item?.estado) === 1,
    );
  }

  onFechaInicioChange(): void {
    const fechaInicio = String(
      this.programaForm.get("fechaInicio")?.value || "",
    ).trim();
    if (!fechaInicio) {
      this.programaForm.patchValue({ fechaFin: "" }, { emitEvent: false });
      return;
    }

    const fechaFin = this.calcularFechaFin(fechaInicio);
    this.programaForm.patchValue({ fechaFin }, { emitEvent: false });
  }

  private calcularFechaFin(fechaInicio: string): string {
    const fecha = new Date(`${fechaInicio}T00:00:00`);
    fecha.setFullYear(fecha.getFullYear() + 1);
    return this.formatearFecha(fecha);
  }

  private obtenerFechaActual(): string {
    const fecha = new Date();
    return this.formatearFecha(fecha);
  }

  private formatearFecha(fecha: Date): string {
    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, "0");
    const day = String(fecha.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  private obtenerMensajesValidacion(): string[] {
    const mensajes: string[] = [];
    const tipoPrograma = this.programaForm.get("tipoPrograma");
    const fechaInicio = this.programaForm.get("fechaInicio");
    const objetivoGeneral = this.programaForm.get("objetivoGeneral");

    if (tipoPrograma?.hasError("required")) {
      mensajes.push("Selecciona el tipo de programa.");
    }

    if (fechaInicio?.hasError("required")) {
      mensajes.push("Selecciona la fecha de inicio.");
    } else if (fechaInicio?.hasError("fechaFutura")) {
      mensajes.push("La fecha de inicio no puede ser posterior a hoy.");
    }

    if (objetivoGeneral?.hasError("required")) {
      mensajes.push("Ingresa el objetivo general.");
    } else if (objetivoGeneral?.hasError("maxlength")) {
      mensajes.push("El objetivo general no puede superar los 2000 caracteres.");
    }

    return mensajes;
  }

  guardar(): void {
    if (this.programaForm.invalid) {
      this.programaForm.markAllAsTouched();
      const mensajesValidacion = this.obtenerMensajesValidacion();
      Swal.fire(
        "Revisa la información",
        mensajesValidacion.length > 0
          ? mensajesValidacion.join("\n")
          : "Revisa los campos marcados antes de guardar.",
        "warning",
      );
      return;
    }

    if (this.modoEdicion) {
      this.actualizarPrograma();
      return;
    }

    const formValue = this.programaForm.getRawValue() as ProgramaFormValue;
    const fechaInicio = String(formValue.fechaInicio || "").trim();

    if (!fechaInicio) {
      Swal.fire("Fecha requerida", "Selecciona la fecha de inicio.", "warning");
      return;
    }

    if (fechaInicio > this.fechaMaximaInicio) {
      Swal.fire(
        "Fecha inválida",
        "La fecha de inicio debe ser hoy o una fecha anterior.",
        "warning",
      );
      return;
    }

    const fechaFin = this.calcularFechaFin(fechaInicio);

    const payload: ProgramaPesvPayload = {
      consecutivo: String(formValue.consecutivo || "").trim(),
      //nombre_programa: Number(formValue.nombrePrograma),
      tipo_programa: Number(formValue.tipoPrograma),
     // riesgo_critico_asociado: Number(formValue.riesgoCriticoAsociado),
      //proceso: Number(formValue.proceso),
      //area: Number(formValue.area),
      //objetivo_pesv_relacionado: Number(formValue.objetivoPesvRelacionado),
      fecha_inicio: fechaInicio,
      fecha_fin: fechaFin,
      objetivo_general: String(formValue.objetivoGeneral || "").trim(),
      estado: 1,
    };

    this.guardando = true;
    this.programaPesvService.create(payload).subscribe({
      next: () => {
        this.guardando = false;
        Swal.fire("Éxito", "Programa PESV guardado correctamente.", "success");
        this.resetearFormularioCreacion();
        this.cargarProgramas();
        this.activeTab = 2;
      },
      error: (error: any) => {
        this.guardando = false;
        console.log("Error al guardar programa PESV:", error);
        const respuesta = error?.error;
        const mensaje =
          respuesta?.message ||
          respuesta?.error ||
          respuesta?.mensaje ||
          "No se pudo guardar el programa PESV.";
        const detalle = respuesta?.detail;
        Swal.fire(
          "Error",
          detalle && detalle !== mensaje ? `${mensaje}\n${detalle}` : mensaje,
          "error",
        );
      },
    });
  }

  private actualizarPrograma(): void {
    if (!this.idProgramaEditando) {
      Swal.fire(
        "Error",
        "No hay un programa seleccionado para editar.",
        "error",
      );
      return;
    }

    const formValue = this.programaForm.getRawValue() as ProgramaFormValue;

    const payload: Partial<ProgramaPesvPayload> = {
      //nombre_programa: Number(formValue.nombrePrograma),
      tipo_programa: Number(formValue.tipoPrograma),
      //riesgo_critico_asociado: Number(formValue.riesgoCriticoAsociado),
      //proceso: Number(formValue.proceso),
      //area: Number(formValue.area),
      //objetivo_pesv_relacionado: Number(formValue.objetivoPesvRelacionado),
      objetivo_general: String(formValue.objetivoGeneral || "").trim(),
    };

    this.guardando = true;
    this.programaPesvService
      .update(this.idProgramaEditando, payload)
      .subscribe({
        next: () => {
          this.guardando = false;
          Swal.fire("Éxito", "Programa actualizado correctamente.", "success");
          this.cancelarEdicion();
          this.cargarProgramas();
          this.activeTab = 2;
        },
        error: (error: any) => {
          this.guardando = false;
          const mensaje =
            error?.error?.error || "No se pudo actualizar el programa.";
          Swal.fire("Error", mensaje, "error");
        },
      });
  }

  private resetearFormularioCreacion(): void {
    this.programaForm.reset();
    this.tiposRiesgoVial = [];
    this.getConsecutivo();
  }

  editarPrograma(programa: any): void {
    if (Number(programa?.estado) !== 1) {
      Swal.fire(
        "Info",
        "Solo se puede editar cuando el registro está activo.",
        "info",
      );
      return;
    }

    const id = Number(programa?.id);
    if (!id) {
      Swal.fire("Error", "No se encontró el id del programa.", "error");
      return;
    }

    this.cargandoEdicion = true;

    this.programaPesvService.getById(id).subscribe({
      next: (response: any) => {
        this.cargandoEdicion = false;

        const data = response?.data ?? response;
        if (!data) {
          Swal.fire(
            "Error",
            "No se pudo cargar la información del programa.",
            "error",
          );
          return;
        }

        this.modoEdicion = true;
        this.idProgramaEditando = id;
        this.seedingEdicion = true;

        this.programaForm.get("fechaInicio")?.disable({ emitEvent: false });

        this.programaForm.patchValue(
          {
            consecutivo: data?.consecutivo ?? "",
           // nombrePrograma: data?.nombre_programa ?? null,
            tipoPrograma: data?.tipo_programa ?? null,
          //  proceso: data?.proceso ?? null,
          //  area: data?.area ?? null,
           // objetivoPesvRelacionado: data?.objetivo_pesv_relacionado ?? null,
            fechaInicio: data?.fecha_inicio ?? "",
            fechaFin: data?.fecha_fin ?? "",
            objetivoGeneral: String(data?.objetivo_general || "").trim(),
          },
          { emitEvent: true },
        );

        if (data?.tipo_programa) {
         
        } else {
          this.seedingEdicion = false;
        }

        this.activeTab = 1;

        Swal.fire({
          icon: "info",
          title: "Editando programa",
          text: "Los datos se cargaron en el formulario. Modifica lo necesario y presiona Actualizar.",
          timer: 2200,
          showConfirmButton: false,
        });
      },
      error: (error: any) => {
        this.cargandoEdicion = false;
        const mensaje =
          error?.error?.error || "No se pudo cargar el programa para editar.";
        Swal.fire("Error", mensaje, "error");
      },
    });
  }

  cancelarEdicion(): void {
    this.modoEdicion = false;
    this.idProgramaEditando = null;
    this.seedingEdicion = false;
    this.programaForm.get("fechaInicio")?.enable({ emitEvent: false });
    this.programaForm.reset();
    this.tiposRiesgoVial = [];
    this.getConsecutivo();
  }

  cambiarEstado(programa: any, estado: number): void {
    const id = Number(programa?.id);
    if (!id) {
      Swal.fire("Error", "No se encontró el id del programa.", "error");
      return;
    }

    const accion = estado === 1 ? "activar" : "inactivar";
    Swal.fire({
      title: `¿Deseas ${accion} este programa?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Sí, ${accion}`,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.programaPesvService.changeEstado(id, estado).subscribe({
        next: () => {
          Swal.fire("Éxito", `Programa ${accion}do correctamente.`, "success");
          this.cargarProgramas();
        },
        error: (error: any) => {
          const mensaje =
            error?.error?.error || `No se pudo ${accion} el programa.`;
          Swal.fire("Error", mensaje, "error");
        },
      });
    });
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  Seguimientos(ProgramaPesv: ProgramaPesv): void {
    console.log("ProgramaPesv", ProgramaPesv);
    Swal.fire({
      title: "Crear seguimientos",
      text: `¿Desea ver los seguimientos para el programa ${ProgramaPesv?.tipoProgramaData?.descripcion ?? '-'}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, Ver",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(["seguimientos/seguimientos", ProgramaPesv.id]);
      }
    });
  }


  private cargarAdministraciones(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data: any[]) => {
        this.administraciones = data ?? [];
        this.nit = this.administraciones?.[0]?.nit ?? null;
      },
      error: () => {
        this.administraciones = [];
        this.nit = null;
      },
    });
  }

  // 🔹 Ruta pedida: {nit}/pesv/programa/{consecutivo}
  private construirCarpetaPrograma(programa: any): string {
    return `pesv/programa/${programa.consecutivo}`;
  }

  private esImagenPorNombre(nombre: string): boolean {
    const ext = nombre.split(".").pop()?.toLowerCase() ?? "";
    return ["jpg", "jpeg", "png", "webp"].includes(ext);
  }

  private isImageFile(file: File): boolean {
    return ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(
      file.type,
    );
  }

  abrirModalDocumentos(modalRef: any, programa: any): void {
    if (!this.nit) {
      Swal.fire(
        "Atención",
        "Aún se está cargando la información de la administración. Intente de nuevo en un momento.",
        "warning",
      );
      return;
    }

    if (!programa?.consecutivo) {
      Swal.fire(
        "Error",
        "El programa no tiene un consecutivo válido.",
        "error",
      );
      return;
    }

    this.programaSeleccionadoDocs = programa;
    this.nuevosArchivosDocs = [];
    this.documentosPlan = [];
    this.cargarDocumentosPlan(programa);

    this.modalService.open(modalRef, {
      size: "lg",
      centered: true,
      backdrop: "static",
    });
  }

  cargarDocumentosPlan(programa: any): void {
    if (!this.nit) return;

    this.cargandoDocumentos = true;
    const carpeta = this.construirCarpetaPrograma(programa); // pesv/programa/{consecutivo}
    const rutaCompleta = `${this.nit}/${carpeta}`;

    this.digitalesService.getDocumentosPlanAccion(rutaCompleta).subscribe({
      next: (resp) => {
        this.documentosPlan = (resp.archivos ?? []).map((a: any) => ({
          name: a.name,
          path: a.path,
          url: a.url,
          isImage: this.esImagenPorNombre(a.name),
        }));
        this.cargandoDocumentos = false;
      },
      error: () => {
        this.documentosPlan = [];
        this.cargandoDocumentos = false;
      },
    });
  }

  subirDocumentosPlan(): void {
    if (
      !this.programaSeleccionadoDocs ||
      this.programaSeleccionadoDocs.estado === 0 ||
      this.nuevosArchivosDocs.length === 0 ||
      !this.nit
    ) {
      return;
    }

    this.subiendoDocumentos = true;
    const carpeta = this.construirCarpetaPrograma(
      this.programaSeleccionadoDocs,
    );
    const rutaCompleta = `${this.nit}/${carpeta}`;
    const pendientes = this.nuevosArchivosDocs.length;
    let completados = 0;
    let subidosConExito = 0;

    this.nuevosArchivosDocs.forEach((item, index) => {
      // 🔹 Nombre único por archivo, evita que se sobreescriban entre sí
      const nombreSinExtension = item.file.name.replace(/\.[^/.]+$/, "");
      const sufijoUnico = `${Date.now()}_${index}_${Math.floor(Math.random() * 10000)}`;
      const nombreArchivo = `${nombreSinExtension}_${sufijoUnico}`;

      this.digitalesService
        .subirDocumentoPlanAccion(
          item.file,
          rutaCompleta,
          nombreArchivo,
          "programa_pesv",
        )
        .subscribe({
          next: (event) => {
            if (event.type === HttpEventType.Response) {
              completados++;
              subidosConExito++;

              if (completados === pendientes) {
                this.subiendoDocumentos = false;
                this.nuevosArchivosDocs = [];
                this.cargarDocumentosPlan(this.programaSeleccionadoDocs);
                Swal.fire(
                  "¡Éxito!",
                  "Documento(s) subido(s) correctamente.",
                  "success",
                );
              }
            }
          },
          error: () => {
            completados++;
            this.subiendoDocumentos = false;

            if (completados === pendientes) {
              this.cargarDocumentosPlan(this.programaSeleccionadoDocs);
            }

            Swal.fire(
              "Error",
              `No se pudo subir el archivo ${item.file.name}.`,
              "error",
            );
          },
        });
    });
  }

  onFileChangeDocumento(event: any): void {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.nuevosArchivosDocs.push({
          file,
          preview: this.isImageFile(file) ? e.target.result : null,
        });
      };
      reader.readAsDataURL(file);
    });

    event.target.value = "";
  }

  quitarArchivoNuevo(index: number): void {
    this.nuevosArchivosDocs.splice(index, 1);
  }

  eliminarDocumento(doc: { name: string; path: string; url: string }): void {
    if (
      !this.programaSeleccionadoDocs ||
      this.programaSeleccionadoDocs.estado === 0
    ) {
      Swal.fire(
        "Acción no permitida",
        "No se puede eliminar documentos de un programa inactivo.",
        "warning",
      );
      return;
    }

    Swal.fire({
      title: "¿Eliminar documento?",
      text: `¿Está seguro de que desea eliminar "${doc.name}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.digitalesService.eliminarArchivo(doc.path).subscribe({
          next: () => {
            this.cargarDocumentosPlan(this.programaSeleccionadoDocs);
            Swal.fire(
              "¡Éxito!",
              "El documento se eliminó correctamente.",
              "success",
            );
          },
          error: () => {
            Swal.fire("Error", "No se pudo eliminar el documento.", "error");
          },
        });
      }
    });
  }

  reemplazarDocumento(doc: { name: string; path: string }): void {
    if (
      !this.programaSeleccionadoDocs ||
      this.programaSeleccionadoDocs.estado === 0
    ) {
      Swal.fire(
        "Acción no permitida",
        "No se puede reemplazar documentos de un programa inactivo.",
        "warning",
      );
      return;
    }

    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".pdf,.jpg,.jpeg,.png,.webp";

    input.onchange = (event: any) => {
      const file: File = event.target.files[0];
      if (!file) return;

      Swal.fire({
        title: "¿Reemplazar documento?",
        text: `Se reemplazará "${doc.name}" por "${file.name}".`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, reemplazar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.subiendoDocumentos = true;

        this.digitalesService.eliminarArchivo(doc.path).subscribe({
          next: () => {
            const carpeta = this.construirCarpetaPrograma(
              this.programaSeleccionadoDocs,
            );
            const rutaCompleta = `${this.nit}/${carpeta}`;
            const nombreSinExtension = file.name.replace(/\.[^/.]+$/, "");
            const sufijoUnico = `${Date.now()}_${Math.floor(Math.random() * 10000)}`;
            const nombreArchivo = `${nombreSinExtension}_${sufijoUnico}`;

            this.digitalesService
              .subirDocumentoPlanAccion(
                file,
                rutaCompleta,
                nombreArchivo,
                "programa_pesv",
              )
              .subscribe({
                next: (event) => {
                  if (event.type === HttpEventType.Response) {
                    this.subiendoDocumentos = false;
                    this.cargarDocumentosPlan(this.programaSeleccionadoDocs);
                    Swal.fire(
                      "¡Éxito!",
                      "Documento reemplazado correctamente.",
                      "success",
                    );
                  }
                },
                error: () => {
                  this.subiendoDocumentos = false;
                  Swal.fire(
                    "Error",
                    "No se pudo subir el nuevo documento.",
                    "error",
                  );
                },
              });
          },
          error: () => {
            this.subiendoDocumentos = false;
            Swal.fire(
              "Error",
              "No se pudo eliminar el documento anterior.",
              "error",
            );
          },
        });
      });
    };

    input.click();
  }

  private obtenerTipoDocumento(
    nombre: string,
  ): "imagen" | "pdf" | "word" | "excel" | "otro" {
    const ext = nombre.split(".").pop()?.toLowerCase() ?? "";
    if (["jpg", "jpeg", "png", "webp"].includes(ext)) return "imagen";
    if (ext === "pdf") return "pdf";
    if (["doc", "docx"].includes(ext)) return "word";
    if (["xls", "xlsx"].includes(ext)) return "excel";
    return "otro";
  }

  verDocumento(
    modalRef: any,
    doc: { name: string; path: string; url: string; isImage: boolean },
  ): void {
    if (!doc.url) return;

    const tipo = this.obtenerTipoDocumento(doc.name);

    this.documentoSeleccionado = {
      ...doc,
      isImage: tipo === "imagen",
      isPdf: tipo === "pdf",
      tipo,
      urlSegura:
        tipo === "pdf"
          ? this.sanitizer.bypassSecurityTrustResourceUrl(doc.url)
          : undefined,
    };

    this.modalService.open(modalRef, {
      size: "xl",
      centered: true,
      backdrop: true,
    });
  }

abrirModalResumenPrograma(modalRef: any, programa: any): void {
  this.programaResumen = programa;
  this.cargandoResumen = true;

  this.modalService.open(modalRef, { size: "xl", centered: true, backdrop: "static" });

  const idPrograma = Number(programa.id);

  this.programaPesvService
    .getResumenPrograma(idPrograma, this.reporteDesde, this.reporteHasta)
    .subscribe({
      next: ({ resumen }) => {
        this.resumen = { ...resumen, totalEvidencias: this.documentosPlan?.length ?? 0 };
        // ... resto igual

        // 🔹 Las evidencias siguen aparte porque viven en GCS, no en una tabla con id_programa
        if (this.nit && programa.consecutivo) {
          const rutaCompleta = `${this.nit}/${this.construirCarpetaPrograma(programa)}`;
          this.digitalesService
            .getDocumentosPlanAccion(rutaCompleta)
            .subscribe({
              next: (resp) => {
                this.resumen.totalEvidencias = (resp.archivos ?? []).length;
                this.cargandoResumen = false;
              },
              error: () => {
                this.cargandoResumen = false;
              },
            });
        } else {
          this.cargandoResumen = false;
        }
      },
      error: () => { this.cargandoResumen = false; },
    });
  }

  colorAvanceResumen(avance: number): string {
    if (avance >= 80) return "success";
    if (avance >= 40) return "warning";
    return "danger";
  }

abrirModalReportes(modalRef: any, programa: any): void {
  this.programaReporteSeleccionado = programa;
  this.reporteTipo = "resumen";
  this.reportePeriodo = "completo";

  this.reporteFechaMinima = programa?.fecha_inicio
    ? String(programa.fecha_inicio).substring(0, 10)
    : "";
  this.reporteFechaMaxima = programa?.fecha_fin
    ? String(programa.fecha_fin).substring(0, 10)
    : "";

  this.aplicarPeriodoReporte();

  this.modalService.open(modalRef, {
    size: "xl",
    centered: true,
    backdrop: "static",
  });
}

aplicarPeriodoReporte(): void {
  const minPrograma = this.reporteFechaMinima;
  const maxPrograma = this.reporteFechaMaxima;

  if (this.reportePeriodo === "personalizado") {
    // El usuario ajusta manualmente Desde; Hasta se mantiene dentro del rango
    if (!this.reporteDesde) this.reporteDesde = minPrograma;
    if (!this.reporteHasta) this.reporteHasta = maxPrograma;
    return;
  }

  if (this.reportePeriodo === "completo") {
    this.reporteDesde = minPrograma;
    this.reporteHasta = maxPrograma;
    return;
  }

  const hoy = new Date();
  let inicioPeriodo: Date;
  let finPeriodo: Date;

  switch (this.reportePeriodo) {
    case "mes":
      inicioPeriodo = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
      finPeriodo = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
      break;

    case "trimestre": {
      const trimestre = Math.floor(hoy.getMonth() / 3); // 0,1,2,3
      inicioPeriodo = new Date(hoy.getFullYear(), trimestre * 3, 1);
      finPeriodo = new Date(hoy.getFullYear(), trimestre * 3 + 3, 0);
      break;
    }

    case "semestre": {
      const semestre = hoy.getMonth() < 6 ? 0 : 1; // 0 = ene-jun, 1 = jul-dic
      inicioPeriodo = new Date(hoy.getFullYear(), semestre * 6, 1);
      finPeriodo = new Date(hoy.getFullYear(), semestre * 6 + 6, 0);
      break;
    }

    case "anual":
      inicioPeriodo = new Date(hoy.getFullYear(), 0, 1);
      finPeriodo = new Date(hoy.getFullYear(), 11, 31);
      break;

    default:
      inicioPeriodo = new Date(minPrograma);
      finPeriodo = new Date(maxPrograma);
  }

  let desdeStr = this.formatearFecha(inicioPeriodo);
  let hastaStr = this.formatearFecha(finPeriodo);

  // 🔹 Recorte dentro de los límites del programa
  if (minPrograma && desdeStr < minPrograma) desdeStr = minPrograma;
  if (maxPrograma && hastaStr > maxPrograma) hastaStr = maxPrograma;

  // 🔹 Si el periodo elegido queda totalmente fuera del rango del programa
  // (ej. "mes actual" en un programa que ya terminó), se avisa y se usa el rango completo.
  if (
    (maxPrograma && desdeStr > maxPrograma) ||
    (minPrograma && hastaStr < minPrograma)
  ) {
    Swal.fire(
      "Fuera de rango",
      "El periodo seleccionado está fuera de las fechas del programa. Se mostrará el rango completo.",
      "info",
    );
    desdeStr = minPrograma;
    hastaStr = maxPrograma;
    this.reportePeriodo = "completo";
  }

  this.reporteDesde = desdeStr;
  this.reporteHasta = hastaStr;
}


private crearEncabezadoReporte(doc: jsPDF, titulo: string): number {
  const programa = this.programaReporteSeleccionado;
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFillColor(13, 71, 161);
  doc.rect(0, 0, pageWidth, 28, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("PLAN ESTRATÉGICO DE SEGURIDAD VIAL", pageWidth / 2, 12, {
    align: "center",
  });

  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.text(titulo, pageWidth / 2, 20, { align: "center" });

  doc.setTextColor(0, 0, 0);
  let y = 36;

  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text("Programa:", 14, y);
  doc.setFont("helvetica", "normal");
  doc.text(String(programa?.nombreProgramaData?.descripcion || "-"), 40, y);

  doc.setFont("helvetica", "bold");
  doc.text("Fecha del reporte:", 120, y);
  doc.setFont("helvetica", "normal");
  doc.text(this.formatearFechaVisual(new Date().toISOString()), 160, y);
  y += 6;

  doc.setFont("helvetica", "bold");
  doc.text("Consecutivo:", 14, y);
  doc.setFont("helvetica", "normal");
  doc.text(String(programa?.consecutivo || "-"), 40, y);

  doc.setFont("helvetica", "bold");
  doc.text("Rango:", 120, y);
  doc.setFont("helvetica", "normal");
  // 🔹 Ahora se formatea igual que el resto de fechas del reporte (dd/mm/yyyy)
  const desdeFormateado = this.reporteDesde
    ? this.formatearFechaVisual(this.reporteDesde)
    : "-";
  const hastaFormateado = this.reporteHasta
    ? this.formatearFechaVisual(this.reporteHasta)
    : "-";
  doc.text(`${desdeFormateado}  a  ${hastaFormateado}`, 160, y);
  y += 10;

  return y;
}

  private crearPiePagina(doc: jsPDF): void {
    const totalPaginas = doc.getNumberOfPages();

    for (let i = 1; i <= totalPaginas; i++) {
      doc.setPage(i);

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      doc.setFontSize(8);
      doc.setTextColor(120, 120, 120);

      doc.text(
        `Página ${i} de ${totalPaginas}`,
        pageWidth - 14,
        pageHeight - 8,
        {
          align: "right",
        },
      );

      doc.text("Generado por el sistema PESV", 14, pageHeight - 8);
    }
  }

  private descargarPDF(doc: jsPDF, nombreArchivo: string): void {
    this.crearPiePagina(doc);
    doc.save(`${nombreArchivo}.pdf`);
  }

  private formatearFechaVisual(fecha: string): string {
    const f = new Date(fecha);
    if (isNaN(f.getTime())) return fecha;
    return this.formatearFecha(f).split("-").reverse().join("/");
  }

  private dentroDeRango(fecha: string | null | undefined): boolean {
    if (!fecha) return true;
    if (!this.reporteDesde && !this.reporteHasta) return true;
    const f = String(fecha).substring(0, 10);
    if (this.reporteDesde && f < this.reporteDesde) return false;
    if (this.reporteHasta && f > this.reporteHasta) return false;
    return true;
  }


 
}
